import { signal } from "@preact/signals-react";
import { cn, colors } from "tools/ui";
import { theme } from "theme/theme";

/**
 * CharFilter — Campo de texto para filtros en tablas
 * -------------------------------------------------
 * Props esperadas:
 *  - name: nombre del campo
 *  - data: signal con el valor actual
 *  - field: definición del layout
 *  - label: etiqueta opcional
 *  - placeholder: texto de ayuda
 *  - readOnly: booleano para solo lectura
 *  - onChange: función(value) → callback al cambiar
 *  - uppercase: fuerza texto en mayúsculas
 *  - specialCharacters: elimina caracteres especiales
 */

const baseStyle = "w-full py-2 px-2";

function CharFilter(props) {
  const {
    name,
    data,
    field,
    label,
    readOnly,
    placeholder,
    onChange,
    required,
    icon,
    uppercase,
    specialCharacters,
    value,
  } = props;

  // Estilos dinámicos
  let _style = baseStyle;
  let _color = props.color ?? "bg-white";
  if (readOnly) _color = colors.readOnly;

  // Maneja cambios en el input
  function handleChange(event) {
    let _value = event.target.value;

    if (uppercase) {
      _value = _value.toUpperCase();
    }

    if (specialCharacters && field?.type === "char") {
      _value = _value.replace(/[^\w\s]|[\dñ]/gi, "");
      _value = _value.replace("  ", " ").toUpperCase();
    }

    // Actualiza el signal local
    data.value = _value;

    // 🔹 Notifica al padre (solo el valor, no el nombre)
    if (onChange) {
      onChange(_value);
    }
  }

  // Opcionalmente dispara onChange al perder foco
  function handleBlur(event) {
    let _value = event.target.value;
    if (onChange) {
      onChange(_value);
    }
  }

  return (
    <div className="">
      <input
        key={name}
        id={name}
        name={name}
        type="text"
        className={cn(
          _color,
          _style,
          theme.textColor,
          theme.border,
          theme.input.height,
        )}
        value={(data?.value ?? value) || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder ? `Filtrar por ${placeholder}` : ""}
      />

      {icon && <div className="absolute right-3 top-2.5">{icon}</div>}
    </div>
  );
}

export default CharFilter;
